import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Models } from '@ibexfusion/models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ScreenService } from '@services/screens/screen.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-screen-selector',
    templateUrl: './screen-selector.component.html',
    styleUrls: ['./screen-selector.component.scss'],
    providers: [ScreenService],
    standalone: false
})
export class ScreenSelectorComponent implements OnInit {

  @ViewChild('hStepper') stepper: MatStepper;

  screens: Models.Screen[];
  customerId: string;
  selectedScreenId: string;
  firstFormGroup: UntypedFormGroup;
  boundScreen: Models.Screen;

  constructor(
    public dialogRef: MatDialogRef<ScreenSelectorComponent>,
    public screenService: ScreenService,
    private formBuilder: UntypedFormBuilder
  ) {
  }

  ngOnInit() {
    this.firstFormGroup = this.formBuilder.group({
      screenId: ['', Validators.required]
    });
  }

  selectScreen(event: DataTableEvent) {
    this.selectedScreenId = event.row._id;
    this.boundScreen = event.row;
    setTimeout(() => {
      this.stepper.next();
    }, 0);
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      screenId: this.selectedScreenId,
      screenUuid: this.boundScreen.uuid
    });
  }

}
